import { useEffect, useRef } from "react";
import { useMutation } from "@apollo/client";
import { useHistory, useLocation } from "@magento/venia-ui/lib/drivers";
import BrowserPersistence from "@overrides_venia/peregrine/util/simplePersistence";
import { CREATE_OR_UPDATE_MEMBER_PARTNERSHIP_QRCODE } from "./partnershipQrcode.gql";
import { GET_CUSTOMER } from "@overrides_venia/peregrine/talons/SignIn/signIn.gql";
import { useAwaitQuery } from "@magento/peregrine/lib/hooks/useAwaitQuery";
const storage = new BrowserPersistence();
const QRCODE_STORAGE_KEY = "partnership_qrcode";
const QRCODE_TTL = 86400;
export const cleanupQrcodeFromUrl = (history, location) => {
  const urlParams = new URLSearchParams(location.search);
  if (urlParams.has("qrcode")) {
    urlParams.delete("qrcode");
    const newSearch = urlParams.toString();
    const newUrl = "".concat(location.pathname).concat(newSearch ? "?".concat(newSearch) : "");
    history.replace(newUrl);
  }
};
export const removeQrcodeFromStorage = () => {
  storage.removeItem(QRCODE_STORAGE_KEY);
};
export const usePartnershipQrcode = _ref => {
  let {
    isSignedIn,
    currentUser,
    getUserDetails
  } = _ref;
  const history = useHistory();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const fetchUserDetails = useAwaitQuery(GET_CUSTOMER);
  const [createOrUpdatePartnershipQrcode] = useMutation(CREATE_OR_UPDATE_MEMBER_PARTNERSHIP_QRCODE, {
    fetchPolicy: "no-cache"
  });
  useEffect(() => {
    if (hasProcessed.current) return;
    const urlParams = new URLSearchParams(location.search);
    const qrcodeFromUrl = urlParams.get("qrcode");
    const qrcodeFromStorage = storage.getItem(QRCODE_STORAGE_KEY);
    const qrcode = qrcodeFromUrl || qrcodeFromStorage;
    if (!qrcode) return;
    if (!isSignedIn) {
      if (qrcodeFromUrl) {
        storage.setItem(QRCODE_STORAGE_KEY, qrcode, QRCODE_TTL);
        cleanupQrcodeFromUrl(history, location);
      }
      return;
    }
    if (!(currentUser !== null && currentUser !== void 0 && currentUser.email)) return;
    hasProcessed.current = true;
    const processQrcode = async () => {
      try {
        await createOrUpdatePartnershipQrcode({
          variables: {
            qrcode
          }
        });
        if (getUserDetails) {
          await getUserDetails({
            fetchUserDetails
          });
        }
        cleanupQrcodeFromUrl(history, location);
        removeQrcodeFromStorage();
      } catch (error) {
        console.error("Error processing partnership QR code:", error);
        cleanupQrcodeFromUrl(history, location);
        removeQrcodeFromStorage();
      }
    };
    processQrcode();
  }, [isSignedIn, currentUser === null || currentUser === void 0 ? void 0 : currentUser.email, location.search]);
  return null;
};